import { Link } from 'react-router-dom';
import './About.css';

const values = [
  { icon: '🙏', title: 'Devotion', desc: 'Every action we take is rooted in devotion to Lord Ganesha and service to his devotees.' },
  { icon: '🤝', title: 'Unity', desc: 'We believe in the power of united mandal — one platform, one voice, one Valsad.' },
  { icon: '💛', title: 'Transparency', desc: 'All donations and activities are openly reported and accounted for, earning community trust.' },
  { icon: '🌱', title: 'Social Impact', desc: 'Beyond celebrations, we drive real change through health camps, environment drives and welfare programmes.' },
];

const team = [
  { name: 'Jayesh Patel', role: 'Founder & President', emoji: '👨‍💼' },
  { name: 'Kiran Desai', role: 'Vice President', emoji: '👨‍💼' },
  { name: 'Meena Shah', role: 'Secretary', emoji: '👩‍💼' },
  { name: 'Rahul Mehta', role: 'Treasurer', emoji: '👨‍💼' },
  { name: 'Priya Joshi', role: 'Social Activities Head', emoji: '👩‍💼' },
  { name: 'Amitbhai Soni', role: 'Digital Coordinator', emoji: '👨‍💼' },
];

const milestones = [
  { year: '2020', event: 'Aarambh conceptualised by a group of Valsad-based devotees.' },
  { year: '2021', event: 'Officially registered as a charitable trust; first 10 mandal onboarded.' },
  { year: '2022', event: 'Launched online donation portal; first blood donation camp organised.' },
  { year: '2023', event: '35+ mandal connected; ₹3L+ collected in donations for community causes.' },
  { year: '2024', event: 'Grand unified Ganesh Chaturthi event with 50+ mandal participation.' },
  { year: '2025', event: 'Expanding scope to include all social activities across Valsad district.' },
];

export default function About() {
  return (
    <div className="about-page">
      {/* Page Hero */}
      <div className="page-hero">
        <div className="container">
          <div className="badge">Our Story</div>
          <h1>About Aarambh</h1>
          <p>A charitable trust born from the devotion of Valsad's Ganpati community — uniting organisations, enabling giving and driving social change.</p>
        </div>
      </div>

      {/* Mission & Vision */}
      <section className="mission-section">
        <div className="container mission-grid">
          <div className="mission-card card">
            <div className="mission-icon">🎯</div>
            <h3>Our Mission</h3>
            <p>To connect every Ganpati Mahotsav Mandal in Valsad district on a single platform — making it easy to co-ordinate celebrations, receive donations and execute social welfare activities in the name of Lord Ganesha.</p>
          </div>
          <div className="mission-card card">
            <div className="mission-icon">🌟</div>
            <h3>Our Vision</h3>
            <p>A Valsad where every neighbourhood's Ganesh Utsav is celebrated with grandeur, every mandal is empowered with resources and every donation reaches those in need — transparently and joyfully.</p>
          </div>
          <div className="mission-card card">
            <div className="mission-icon">🏆</div>
            <h3>Our Goal</h3>
            <p>To become the most trusted charitable platform for Ganpati Mahotsav organisations in Gujarat — starting from Valsad and eventually connecting mandal across the state and beyond.</p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">What Drives Us</div>
            <h2>Our Core Values</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="values-grid">
            {values.map((v) => (
              <div key={v.title} className="value-card card">
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Milestones */}
      <section className="milestones-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">Our Journey</div>
            <h2>Milestones</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="timeline">
            {milestones.map((m, i) => (
              <div key={m.year} className={`timeline-item${i % 2 === 0 ? ' left' : ' right'}`}>
                <div className="timeline-year">{m.year}</div>
                <div className="timeline-dot" />
                <div className="timeline-content card">
                  <p>{m.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">The People</div>
            <h2>Our Leadership Team</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="team-grid">
            {team.map((m) => (
              <div key={m.name} className="team-card card">
                <div className="team-avatar">{m.emoji}</div>
                <h3>{m.name}</h3>
                <p>{m.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2>Ready to Join Our Mission?</h2>
          <p>Register your mandal, make a donation or volunteer for social activities — every contribution matters.</p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '28px', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn-primary">Register Mandal</Link>
            <Link to="/donate" className="btn-outline">Make a Donation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
